import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import { Footer } from "../../../components/Footer";
import { Nav } from "../../../components/common/FrontendNav";
import { PostOrPage } from "@tryghost/content-api";
import getPage from "../../../news/getPage";
import { StaticGhostPage } from "../../../components/StaticGhostPage";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { getSidebar } from "@/data/news";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const page = await getPage(
    context.locale === "de"
      ? "646de2efa89bd3000174ec7b"
      : "64cb637a193d060001d02e61",
  );
  const sidebar = await getSidebar(context.locale);
  return {
    props: {
      page,
      sidebar,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface NewsPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
}
export default function NewsPage({ page, sidebar }: NewsPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t(
          "Title_Team",
        )}`}</title>
      </Head>
      <div>
        <Nav />
        <StaticGhostPage page={page} sidebar={sidebar} />
        <Footer />
      </div>
    </>
  );
}
